<template>
<v-layout column>
    <v-form ref="editForm" v-model="formValid">
        <v-layout class="dialog-content" align-center justify-center>
            <v-flex xs12 md9 lg6>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-autocomplete label="Location" :items="getLocations.filter(l=> l.IsActive || (cropCopy != null && cropCopy.LocationID != null && cropCopy.LocationID == l.LocationID))" item-value="LocationID" item-text="Name" v-model="crop.LocationID" :rules="[rules.requiredObject]" box clearable placeholder="Select Location">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                        <v-autocomplete label="Product Type" :disabled="clone" :items="getProductTypes" item-value="ProductTypeID" item-text="Name" v-model="crop.ProductTypeID" :rules="[rules.requiredObject]" box clearable placeholder="Select Product Type">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12>
                        <v-menu v-model="plantingMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field :value="formatDate(earliestPlatingDate)" label="Planting Date(Read Only)" prepend-icon="event" readonly v-on="on" disabled></v-text-field>
                            </template>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12>
                        <v-menu v-model="startMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field :value="formatDate(crop.StartDate)" label="Start Date" prepend-icon="event" readonly v-on="on" append-icon="close" :rules="[rules.required]" @click:append="clearStartDate"></v-text-field>
                            </template>
                            <v-date-picker :value="formatDateYMD(crop.StartDate)" @input="updateStartDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12>
                        <v-menu v-model="endMenu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field :value="formatDate(crop.EndDate)" label="End Date" prepend-icon="event" readonly v-on="on" append-icon="close" :rules="[rules.required]" @click:append="clearEndDate"></v-text-field>
                            </template>
                            <v-date-picker :value="formatDateYMD(crop.EndDate)" @input="updateEndDate"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12>
                        <v-autocomplete label="Financial Year" :items="getFinancialYears" item-value="Year" item-text="Label" v-model="crop.FinancialYear" :rules="[rules.requiredObject]" box clearable placeholder="Select Financial Year">
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs4>
                        <label-value :label="'Crop Code'" :value="cropCode"></label-value>
                    </v-flex>
                    <v-flex xs4>
                        <label-value :label="'Total Area (Hectares)'" :value="cropArea"></label-value>
                    </v-flex>
                    <v-flex xs4>
                        <label-value :label="'Total Number of Bushes'" :value="cropTotalBushes"></label-value>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-form>
    <v-layout row align-center justify-center>
        <v-flex xs12 md9 lg6>
            <v-layout row>
                <v-flex xs6 pa-2>
                    <v-btn color="error" block @click="$emit('cancel')">Cancel</v-btn>
                </v-flex>
                <v-flex xs6 pa-2>
                    <v-btn color="primary" :disabled="!formValid" block @click="next" :loading="submitLoading">Next</v-btn>
                </v-flex>                
            </v-layout>
        </v-flex>
    </v-layout>
    <v-alert :value="submitError != null" outline type="error">
        <span>{{ submitError }}</span>
    </v-alert>
    <confirm-dialog :DisplayDialog="showConfirmApply" :DialogTitle="'Override all the latest Variety Attribute to-dates with the new End Date'" :DialogContents="'Are you sure you wish to override all the latest Variety Attribute to-dates?'" @No="showConfirmApply = false" @Yes="confirmApply"></confirm-dialog>
</v-layout>
</template>

<script>
import UtilService from '@/services/utilService.js';
import validationRules from "@/helpers/validationrules";
import LabelValue from '@/components/generic/LabelValue.vue';
import ConfirmDialog from '@/components/generic/YesNoPopup.vue';
import moment from 'moment';

import {
    mapGetters
} from 'vuex';

export default {
    components: {
        LabelValue: LabelValue,
        ConfirmDialog:ConfirmDialog
    },
    props: {
        crop: {
            required: true,
            type: Object
        },
        clone: {
            requried: true,
            type: Boolean
        },
        submitError: {
            required: false,
            type: String
        },
        submitLoading: {
            required: false,
            type: Boolean
        },
    },
    data() {
        return {
            rules: validationRules.rules,
            formValid: true,
            plantingMenu: false,
            startMenu: false,
            endMenu: false,
            cropCopy: null,
            earliestPlatingDate:'',
            showConfirmApply: false
        }
    },
    computed: {
        ...mapGetters("CropStore", [
            "getLocations",
            "getProductTypes",
            "getFinancialYears",
            "getAttributeEnum"
        ]),
        cropCode() {
            let plantCode = '';
            let year = '';
            let date = '';
            let productTypeCode = '';
            let locationCode = '';
            let identifier = 'N';

            if (this.crop.LocationID) {
                let location = this.getLocations.find(l => l.LocationID === this.crop.LocationID);
                plantCode = location.PlantCode.trim();
                locationCode = location.LocationCode.trim();
            }

            if (this.crop.StartDate) {
                date = moment(this.crop.StartDate).format('MMDD');
            }

            if (this.crop.FinancialYear) {
                year = this.crop.FinancialYear.toString().substring(2);
            }

            if (this.crop.ProductTypeID) {
                let productType = this.getProductTypes.find(p => p.ProductTypeID === this.crop.ProductTypeID);
                productTypeCode = productType.Code;
            }

            return `${plantCode}${year}${date}-${productTypeCode}${locationCode}${identifier}`;
        },
        cropArea() {
            let area = 0;            

            for (const cropVariety of this.crop.CropVarieties) {
                const areaAttribute = cropVariety.Attributes.find(a => a.AttributeID === this.getAttributeEnum.VarietyAreaHectares);

                if (areaAttribute != null) {
                    let value = areaAttribute.Values.sort((a, b) => { return moment(a.StartDate).isSameOrBefore(moment(b.StartDate)) ? 1 : -1 })[0];

                    if (value) {
                        area += parseFloat(value.UserDefinedValue);
                    }
                }
            }

            return area;
        },
        cropTotalBushes() {
            let numberOfBushes = 0;

            for (const cropVariety of this.crop.CropVarieties) {
                const numberOfBushesAttribute = cropVariety.Attributes.find(a => a.AttributeID === this.getAttributeEnum.VarietyNumberOfBushes);

                if (numberOfBushesAttribute != null) {
                    let value = numberOfBushesAttribute.Values.sort((a, b) => { return moment(a.StartDate).isSameOrBefore(moment(b.StartDate)) ? 1 : -1 })[0];

                    if (value) {
                        numberOfBushes += parseFloat(value.UserDefinedValue);
                    }
                }
            }

            return numberOfBushes;
        }
    },
    methods: {
        clearPlantingDate() {
            this.plantingMenu = true;
            this.$set(this.crop, 'PlantingDate', null);
            this.plantingMenu = false;
        },
        updatePlantingDate(v) {
            this.$set(this.crop, 'PlantingDate', v);
            this.plantingMenu = false;
        },
        clearStartDate() {
            this.startMenu = true;
            this.$set(this.crop, 'StartDate', null);
            this.startMenu = false;
        },
        updateStartDate(v) {
            this.$set(this.crop, 'StartDate', v);
            this.startMenu = false;
        },
        clearEndDate() {
            this.endMenu = true;
            this.$set(this.crop, 'EndDate', null);
            this.endMenu = false;
        },
        updateEndDate(v) {
            this.$set(this.crop, 'EndDate', v);
            this.endMenu = false;
            this.showConfirmApply = true;
        },
        formatDate(v) {
            if (v) {
                return UtilService.formatDateDMY(v, '/');
            }

            return null;
        },
        formatDateYMD(v) {
            if(v) {
                return UtilService.formatDateYMD(v);
            } 
            return null;
        },
        next() {
            this.crop.CropCode = this.cropCode;
            this.$emit('next');
        },
        calculateEarliestPlantingDate() {
            
            if(this.crop.CropVarieties.length>0){
                const variety = this.crop.CropVarieties.reduce((a,b)=>{
                    return a.PlantingDate < b.PlantingDate ? a : b;
                })
                this.earliestPlatingDate = variety.PlantingDate;
                this.crop.PlantingDate = variety.PlantingDate; 
            }
        },
        confirmApply(){
            this.$emit("updateToDate");
            this.showConfirmApply = false;
        }
    },
    created() {
        this.cropCopy = this.crop;
        this.calculateEarliestPlantingDate();
    }
}
</script>
